import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { Modal } from 'react-bootstrap';
import PolicyNumberField from './PolicyNumberField';
import CreditCardField from './CreditCardField';
import CancelAcceptField from './CancelAcceptField';
import ZipField from './ZipField';
import {
  required,
  fourDigits,
  fiveDigits,
  checked,
  zipCodePlus4,
} from '../../Helpers/validators';
import { normalizeZipPlus4, normalizeDigits } from '../../Helpers/normalizers';
import { Button } from '@jauntin/react-ui';

const RefundCancel = ({
  waiting,
  disabled,
  cancelPolicy,
  policyCancelled,
  cancelCreditCard,
  referenceNumber,
  policyNumber,
  contactEmail,
}) => {
  const [showModal, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return policyCancelled ? (
    <div className="container">
      <div className="row">
        <div className="col-lg-8">
          <h2>Your event insurance policy has been cancelled.</h2>
          <br />
          <h5>
            <div>
              <strong>Reference Number: #{referenceNumber}</strong>
            </div>
            <div>
              <strong>Policy Number: #{policyNumber}</strong>
            </div>
          </h5>
          <br />
          <p>
            The premium cost has been refunded to credit card with the last four
            digits of {cancelCreditCard}. You will receive an email shortly at{' '}
            {contactEmail} with a copy of your refund receipt.
          </p>
        </div>
      </div>
    </div>
  ) : (
    <>
      <div>
        <div className="row mr-0">
          <div className="col-lg-8">
            <h3 className="mt-3">Cancel Your Event Insurance Policy</h3>
            <div className="card">
              <div className="card-body">
                <Field
                  component={PolicyNumberField}
                  validate={[required, fiveDigits]}
                  name="cancelPolicyNumber"
                  type="text"
                  normalize={normalizeDigits(5)}
                />

                <Field
                  component={CreditCardField}
                  validate={[required, fourDigits]}
                  name="cancelCreditCard"
                  type="text"
                  normalize={normalizeDigits(4)}
                />

                <Field
                  component={ZipField}
                  validate={[required, zipCodePlus4]}
                  name="cancelZip"
                  type="text"
                  normalize={normalizeZipPlus4}
                />

                <Field
                  component={CancelAcceptField}
                  validate={[checked]}
                  name="cancelAccept"
                  type="checkbox"
                />

                <hr />

                <div className="text-right">
                  <Button
                    onClick={() => cancelPolicy(handleShow)}
                    text="Submit"
                    className="btn-primary"
                    disabled={waiting || !disabled}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal
        show={showModal}
        onHide={handleClose}
        dialogClassName="modal--width-md px-md-5"
      >
        <Modal.Header closeButton>
          <h2 className="modal-title h3">&nbsp;</h2>
        </Modal.Header>
        <Modal.Body>
          <p className="mb-3 text-center">
            Your request could not be processed at this time. Please call{' '}
            <a
              href="tel:+1-844-747-6240"
              className="pl-1 footer__help-num nowrap"
            >
              (844) 747-6240
            </a>{' '}
            or email us at{' '}
            <a
              href="mailto:gatherguard@intactinsurance.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <strong>gatherguard@intactinsurance.com</strong>
            </a>
            .
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button
            text="Ok"
            className="btn-primary float-right px-5"
            onClick={handleClose}
          />
        </Modal.Footer>
      </Modal>
    </>
  );
};

RefundCancel.propTypes = {
  waiting: PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired,
  cancelPolicy: PropTypes.func.isRequired,
  policyCancelled: PropTypes.bool.isRequired,
  cancelCreditCard: PropTypes.string.isRequired,
  referenceNumber: PropTypes.string,
  policyNumber: PropTypes.string,
  contactEmail: PropTypes.string,
};

RefundCancel.defaultProps = {
  referenceNumber: null,
  policyNumber: null,
  contactEmail: null,
};

export default RefundCancel;
